export interface EntitlementLink {
  id: string;
  providerType: string;
  providerUserId: string;
  isActive: boolean;
  lastSyncedAt: string | null;
}

export interface ApiEntitlementLink {
  id: string;
  provider_type: string;
  provider_user_id: string;
  is_active: boolean;
  last_synced_at: string | null;
}

export function mapEntitlementLink(link: ApiEntitlementLink): EntitlementLink {
  return {
    id: link.id,
    providerType: link.provider_type,
    providerUserId: link.provider_user_id,
    isActive: link.is_active,
    lastSyncedAt: link.last_synced_at,
  };
}
